import {useEffect, useMemo, useState} from "react";
import {CUSTOMERS_DELETED_RESTORE, CUSTOMERS_DELETED_TABLE} from "v4/data/apiRoutes";
import useFetch from "v4/hooks/useFetch";
import {generateUrl} from "v4/services/api.service";

export default function useDeletedCustomers(refreshDeletedCustomers, refreshComponents) {
    const [{data}, fetchDeletedCustomersTable] = useFetch();
    const [{isFinished, isLoading}, fetchRestoreCustomer] = useFetch();
    const [rowRestoring, setRowRestoring] = useState(null);
    const deletedCustomersTableRaw = data?.['hydra:member'] ?? [];
    const deletedCustomersTable = useMemo(() => {
        if (!deletedCustomersTableRaw.results?.length) return [];

        const headers = [...deletedCustomersTableRaw.headers.map(({key}) => key), 'actions'];
        const rows = deletedCustomersTableRaw.results.map(({fields, metadata}) => {
            return {
                ...fields.reduce((acc, {key, value}) => {
                    acc[key] = value;
                    return acc;
                }, {}),
                id: metadata.id,
            }
        });

        return {
            headers,
            rows,
        }
    }, [deletedCustomersTableRaw]);


    useEffect(() => {
        fetchDeletedCustomersTable({
            url: generateUrl(CUSTOMERS_DELETED_TABLE)
        });
    }, [fetchDeletedCustomersTable, refreshDeletedCustomers]);

    const onRestore = (row) => () => setRowRestoring(row);

    const confirmRestore = () => {
        fetchRestoreCustomer({
            url: generateUrl(CUSTOMERS_DELETED_RESTORE, {id: rowRestoring.id}),
            config: {
                method: 'POST',
            }
        });
    }

    useEffect(() => {
        if (isFinished) {
            refreshComponents();
        }
    }, [isFinished, refreshComponents]);

    return {
        deletedCustomersTable,
        onRestore,
        rowRestoring,
        closeRestoreConfirm: () => setRowRestoring(null),
        confirmRestore,
        isConfirmLoading: isLoading,
    }
}
